import { api, unwrap } from '@saas-kit/lib';

export type InvoiceStatus = 'draft' | 'issued' | 'paid' | 'past_due' | 'void';
export type PaymentStatus = 'recorded' | 'void';
export type PaymentMethod =
  | 'bank_transfer'
  | 'cash'
  | 'check'
  | 'external_wire'
  | 'other';

export interface InvoiceRecord {
  id: string;
  tenant_id: string;
  subscription_id: string | null;
  invoice_number: string;
  status: InvoiceStatus;
  currency: string;
  subtotal_amount: string;
  tax_amount: string;
  total_amount: string;
  amount_paid: string;
  issued_at: string | null;
  due_at: string | null;
  paid_at: string | null;
  voided_at: string | null;
  notes: string | null;
  metadata: Record<string, unknown>;
}

export interface PaymentRecord {
  id: string;
  tenant_id: string;
  invoice_id: string;
  amount: string;
  currency: string;
  payment_method: PaymentMethod;
  status: PaymentStatus;
  reference: string | null;
  received_at: string;
  recorded_by_user_id: string;
  voided_at: string | null;
  notes: string | null;
  metadata: Record<string, unknown>;
}

export interface InvoicePage {
  total: number;
  offset: number;
  limit: number;
}

export interface InvoiceList {
  items: InvoiceRecord[];
  page: InvoicePage;
}

export interface InvoiceDetail {
  invoice: InvoiceRecord;
  payments: PaymentRecord[];
}

export interface ListInvoicesParams {
  offset?: number;
  limit?: number;
}

export async function listInvoices(
  params: ListInvoicesParams = {},
): Promise<InvoiceList> {
  return unwrap<InvoiceList>(
    api.get('/billing/invoices', {
      params: {
        offset: params.offset ?? 0,
        limit: params.limit ?? 25,
      },
    }),
  );
}

export async function getInvoice(invoiceId: string): Promise<InvoiceDetail> {
  return unwrap<InvoiceDetail>(api.get(`/billing/invoices/${invoiceId}`));
}
